export const selectRangingFilters = (state) => state.baseRangingFilters;

export const selectRangingFilterStrategy = (state) =>
    state.baseRangingFilters.rangingStrategy;
export const selectRangingFilterSort = (state) =>
    state.baseRangingFilters.identifyOption;
